import { WalletName, WalletType } from "@goblinhunt/cosmes/wallet";
import { useWallet } from "provider/WalletProvider";
import { useEffect } from "react";
import { Link } from "react-router-dom";
import { formatAddress } from "utils/Helpers";

export function TestingConnect() {
    const { connect, address, disconnect } = useWallet()


    useEffect(() => {
        const container = document.querySelector(".connect-container")!;
        if (address) container.setAttribute("data-wallet-address", address)
    }, [address])


    useEffect(() => {
        let vuplex = (window as any).vuplex;
        if (vuplex) {
            vuplex.postMessage({ type: 'test', message: 'Just a test' });
        } else {
            window.addEventListener('vuplexready', () => {
                vuplex.postMessage({ type: 'test', message: 'Just a test' });
            });
        }
    }, [])

    return <div className="container-xxl container-p-y connect-container">
        {
            !address && <div className="row mt-3">
                <div className="d-grid gap-2 col-lg-6 mx-auto">
                    <button onClick={() => connect(WalletName.KEPLR, WalletType.EXTENSION)} className="btn btn-info btn-lg" type="button">Keplr Extension</button>
                    <button onClick={() => connect(WalletName.STATION, WalletType.EXTENSION)} className="btn btn-info btn-lg" type="button">Station Extension</button>
                    <button onClick={() => connect(WalletName.KEPLR, WalletType.WALLETCONNECT)} className="btn btn-info btn-lg" type="button">Keplr Mobile</button>
                    <button onClick={() => connect(WalletName.STATION, WalletType.WALLETCONNECT)} className="btn btn-info btn-lg" type="button">Station Mobile</button>
                </div>
            </div>
        }

        {
            address && <div className="row mt-3">
                <div className="d-grid gap-2 col-lg-6 mx-auto">
                    <button onClick={() => disconnect()} className="btn btn-info btn-lg" type="button">Disconnect ({formatAddress(address)})</button>
                </div>
            </div>
        }

    </div>
}